import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainAssetManagement from "./MainAssetManagement";
import ViewContainers from "./ViewContainers";
import ViewDevices from "./ViewDevices";
import ViewAssetGroups from "./ViewAssetGroups";
import ViewDeviceGroups from "./ViewDeviceGroups";
import ViewAssetImport from "./ViewAssetImport";
import FormImport from "./imports/FormImport";
import ViewImports from "./ViewImports";
import ViewIslands from "./ViewIslands";
import ViewExport from "./ViewExport";

// prettier-ignore
const RoutesAssetManagement = () => {

    return (
        <>
            <Route path="asset-management" element={<PrivateRoute role="tech"><MainAssetManagement /></PrivateRoute>} />
            <Route path="asset-management/containers" element={<PrivateRoute role="tech"><ViewContainers /></PrivateRoute>} />
            <Route path="asset-management/devices" element={<PrivateRoute role="admin"><ViewDevices /></PrivateRoute>} />
            <Route path="asset-management/groups" element={<PrivateRoute role="tech" panelType="w"><ViewAssetGroups /></PrivateRoute>} />
            <Route path="asset-management/device_groups" element={<PrivateRoute role="admin"><ViewDeviceGroups /></PrivateRoute>} />
            <Route path="asset-management/imports/import" element={<PrivateRoute role="admin"><ViewAssetImport /></PrivateRoute>} />
            <Route path="asset-management/imports/import/:token" element={<PrivateRoute role="admin"><FormImport /></PrivateRoute>} />
            <Route path="asset-management/imports" element={<PrivateRoute role="admin"><ViewImports /></PrivateRoute>} />
            <Route path="asset-management/islands" element={<PrivateRoute role="tech" panelType="w"><ViewIslands /></PrivateRoute>} />
            <Route path="asset-management/exports" element={<PrivateRoute role="admin"><ViewExport /></PrivateRoute>} />
        </>
    )
}
export default RoutesAssetManagement;
